
import { Ref, defineComponent, ref } from "vue";
import SearchDropdown from "./SearchDropdown.vue";
import { Services } from "../services/services";

export default defineComponent({
    props: {
        criticalCss: String,
        afterCss: String,
        appCss: String,
        oldFooter: HTMLElement,
        services: Services
    },
    setup(props, context) {
        // const inst = getCurrentInstance();
        // if (inst) {
        //     Object.assign(inst.appContext, vueApp._context);
        //     Object.assign(inst.appContext.provides, vueApp._context.provides);
        // }

        // onMounted(() => {
        //     // console.log(props.criticalCss);
        //     // console.log(`the component is now mounted.`);
        // });
        const mainElement: Ref<HTMLElement | undefined> = ref();

        let navContent = null;
        let contactColumn = null;
        const firstRowSelector = ".row.text-sm-center-var.ftr-top";
        if (props.oldFooter) {
            console.log($(props.oldFooter));
            navContent = $(props.oldFooter).find(firstRowSelector + ">.col-xl-17");

            contactColumn = $(props.oldFooter).find(firstRowSelector + ">aside.col-xl-7 ");
            contactColumn.find(`ul li:nth-of-type(${new Date().getUTCDay()})`).css("color", "rgb(250, 167, 39)");
        }

        const hasComgateEnabled = ["hu", "ro", "si", "de"].includes(props?.services?.getLanguage() || "");
        const footerPaymentMethodsImgClass =
            "col-" +
            Math.floor(20 / (hasComgateEnabled ? 4 : 3)) +
            " col-md-" +
            Math.floor(16 / (hasComgateEnabled ? 4 : 3)) +
            " col-lg-" +
            Math.floor(10 / (hasComgateEnabled ? 4 : 3));

        const footerSocialImgClass =
            "col-" +
            Math.floor(12 / (hasComgateEnabled ? 4 : 3)) +
            " col-md-" +
            Math.floor(12 / (hasComgateEnabled ? 4 : 3)) +
            " col-lg-" +
            Math.floor(12 / (hasComgateEnabled ? 4 : 3));
        return {
            mainElement,
            navContent: navContent?.html(),
            contactColumn: contactColumn?.html(),
            localizator: props?.services?.getLocalizator(),
            language: props?.services?.getLanguage() || "",
            baseUrl: props?.services?.getBasePluginUrl() || "",
            heurekaImagePresent: ["hu", "ro", "bg", "sk", "si", "cz"].includes(props?.services?.getLanguage() || ""),
            hasComgateEnabled,
            footerPaymentMethodsImgClass,
            footerSocialImgClass
        };
    },
    components: { SearchDropdown }
});
